/* eslint-disable react/prop-types */
import React from "react";
import logo from "../../assets/favicon.png";
import Header from "../Header";

function Layout({children,  withFooter = true}) {

  return <>
    <Header/>
    <div className="main" >
      {children}
      { withFooter && <footer style={{backgroundColor: '#695036'}}>
        <img  src={logo} alt="logo" />
      </footer>}
    </div>
  </>
}

export default Layout;
